export default {"src":"/_next/static/media/Gift.a0dcfe88.svg","height":238,"width":239,"blurWidth":0,"blurHeight":0};